// @import_dependencies_node Import libraries
import { store } from 'app_storage/redux-storage'
// @end

// @import types
import {
  IAcademicResourceCategory,
  IAcademicResourceConfigCategory,
  IQuestionCategory,
  TypeAcademicResourceCategories,
  TypeAcademicResourceConfigCategories,
  TypesQuestionCategories
} from 'app_types/userTypes'
// @end

// ==========================================================================================
//                                    PENDIENTES
// ==========================================================================================
// - Cuando la data sea null no enviar nada (Por definir)
// - Crear función opcional de error cuando la data sea null o se obtenga algún error
// ==========================================================================================
interface ISubcriptor{
  root: string
  functions: ((data?: any)=>void) []
  lastData: any
}
class StoreService {
  static myInstance: StoreService | null = null
  private storeObject = store
  private subscriptors: ISubcriptor[] = []

  static getInstance(){
    if(StoreService.myInstance === null){
      StoreService.myInstance = new StoreService()
    }
    return this.myInstance
  }

  constructor(){
    this.storeObject.subscribe(this.handleChangeStore)
  }

  public dispatch =  (callback: any) => {
    this.storeObject.dispatch(callback)
  }

  // @INFO Enviar datos a los suscriptores
  private handleChangeStore = () => {
    if(StoreService.myInstance === null) return
    try {
      this.subscriptors.forEach(subs => {
        const data = this.getDataRoot(subs.root)
        if(JSON.stringify(subs.lastData) === JSON.stringify(data)) return
        subs.lastData = data
        subs.functions.forEach(fn => {
          if(data === undefined){
            fn(data)
          }else{
            fn(JSON.parse(JSON.stringify(data)))
          }
        })
      })
    } catch (error) {}
  }

  // @INFO agregar suscriptor
  public subscribe(root: string, fn: (data?:any)=>void, firstSend: boolean = true, since?: string){
    // Enviar dato al que se suscribe
    const data = this.getDataRoot(root)
    if(firstSend){
      if(data === undefined){
        fn(data)
      }else{
        fn(JSON.parse(JSON.stringify(data)))
      }
    }
    // Agregar el nuevo suscriptor al array
    const index = this.subscriptors.findIndex(subs => subs.root === root)
    if(index >= 0){
      this.subscriptors[index].functions.push(fn)
    }else{
      this.subscriptors.push({root, functions: [fn], lastData: data})
    }
  }

  // @INFO remover suscriptor
  public unsubscribe(root: string, fn: (data?:any)=>void){
    const index = this.subscriptors.findIndex(subs => subs.root === root)
    if(index < 0) return
    const idxFunc = this.subscriptors[index].functions.findIndex(func => func === fn)
    if(idxFunc < 0) return
    this.subscriptors[index].functions.splice(idxFunc, 1)
    // Si ya no hay funciones elimino el root
    if(this.subscriptors[index].functions.length === 0){
      this.subscriptors.splice(index, 1)
    }
  }

  // @INFO Encontrar la informacion segun la ruta
  private getDataRoot(root: string){
    const roots = root.split('.')
    const value = roots.reduce((acum: any, item: string) => {
      if(acum === undefined || acum === null) return undefined
      acum = acum[item]
      return acum
    }, {...this.storeObject.getState()})
    return value
  }

  /**
   * @INFO Obtener id de categoría para preguntas
   * @param name
   */
   public getQuestionCategoryFromName = (name: TypesQuestionCategories) => {
    const aux = this.storeObject.getState().auth.user?.questionCategories
    if(!aux) return undefined
    const categories = [...(aux as IQuestionCategory[])]
    let response: string = ''
    if(categories){
        const idx = categories.findIndex(item => item.name === name)
        if(idx >= 0){
            response = categories[idx]._id
        }
    }
    return response
  }

  /**
   * @INFO Obtener id de categoría para recurso académico
   * @param name
   */
   public getAcademicResourceCategoryFromName = (name: TypeAcademicResourceCategories) => {
    const aux = this.storeObject.getState().auth.user?.academicResourceCategories
    if(!aux) return undefined
    const categories = [...(aux as IAcademicResourceCategory[])]
    let response: string = ''
    if(categories){
        const idx = categories.findIndex(item => item.name === name)
        if(idx >= 0){
            response = categories[idx]._id
        }
    }
    return response
  }

  /**
   * @INFO Obtener id de categoría para la configuración del recurso académico
   * @param name
   */
  public getAcademicResourceConfigCategoryFromName = (name: TypeAcademicResourceConfigCategories) => {
    const aux = this.storeObject.getState().auth.user?.academicResourceConfigCategories
    if(!aux) return undefined
    const categories = [...(aux as IAcademicResourceConfigCategory[])]
    let response: string = ''
    if(categories){
        const idx = categories.findIndex(item => item.name === name)
        if(idx >= 0){
            response = categories[idx]._id
        }
    }
    return response
  }

  public getMoodleAuthStatus = () => {
    const status = this.storeObject.getState().auth.moodleAuth
    return status;
  }
}

const storeService = StoreService.getInstance()

export default storeService
